export default {
  // Navbar
  nav_brand: 'CSSBuy Spreadsheet',
  nav_home: 'Home',
  nav_articles: 'Articles',
  nav_categories: 'Categories',
  nav_shopping_guide: 'Shopping Guide',
  nav_language: 'Language',
  nav_english: 'English',
  nav_portuguese: 'Português',
  nav_german: 'Deutsch',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Find Products, Sellers & Useful Resources',
  hero_subtitle: 'Find and organize information about products, sellers, QC, shipping and shopping on CSSBuy in one place. Explore our CSSBuy Spreadsheet and discover useful resources to research better before buying.',
  hero_cta_primary: 'Explore CSSBuy Spreadsheet',
  hero_cta_secondary: 'Visit Main Website',
  hero_trust_1: 'Organized resources',
  hero_trust_2: 'Updated guides',
  hero_trust_3: 'Easy research',
  hero_trust_4: 'Safety information',
  hero_trust_5: 'Independent content',

  // Categories Dropdown
  categories_title: 'Product Categories',
  categories_shoes: 'Shoes',
  categories_hoodies: 'Hoodies/Sweaters',
  categories_tshirts: 'T-Shirts',
  categories_jackets: 'Jackets',
  categories_pants: 'Pants/Shorts',
  categories_headwear: 'Headwear',
  categories_sets: 'Sets',
  categories_underwear: 'Underwear',
  categories_jersey: 'Jersey',
  categories_accessories: 'Accessories',
  categories_bags: 'Bags',
  categories_belts: 'Belts',
  categories_perfumes: 'Perfumes',
  categories_other: 'Other Stuff',

  // Products Catalog
  products_title: 'Browse Products',
  products_subtitle: 'Browse our curated collection of products from trusted sellers. Click any item to view details and purchase.',
  products_view_all: 'View All',

  // Category Buttons
  cat_buttons_title: 'Popular Categories',
  cat_buttons_subtitle: 'Find what you are looking for and explore our CSSBuy product selection',

  // How It Works
  how_title: 'How It Works',
  how_step1: 'Find a product',
  how_step1_desc: 'Browse categories and find the item you are looking for',
  how_step2: 'Compare information',
  how_step2_desc: 'Compare prices, sellers and quality reviews',
  how_step3: 'Research the seller',
  how_step3_desc: 'Check the seller\'s reputation and history',
  how_step4: 'Check QC',
  how_step4_desc: 'Analyze Quality Check photos before confirming',
  how_step5: 'Check shipping and costs',
  how_step5_desc: 'Calculate total cost including shipping and fees',
  how_step6: 'Make your decision',
  how_step6_desc: 'Buy safely based on verified information',

  // Featured Articles
  articles_title: 'CSSBuy Guides & Resources',
  articles_subtitle: 'Useful articles to help you navigate the CSSBuy world',
  articles_read_more: 'Read More',
  articles_seo_title: 'What is CSSBuy Spreadsheet? Complete Guide 2026',
  articles_seo_desc: 'Discover how to use the CSSBuy Spreadsheet to find products, trusted sellers and save on your purchases. Complete guide for beginners.',

  // Comparison
  comparison_title: 'Why use CSSBuy Spreadsheet?',
  comparison_header_feature: 'Feature',
  comparison_header_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_header_manual: 'Manual Search',
  comparison_org: 'Organization',
  comparison_org_high: 'High',
  comparison_org_low: 'Low',
  comparison_filters: 'Filters',
  comparison_yes: 'Yes',
  comparison_no: 'Limited',
  comparison_compare: 'Comparison',
  comparison_easy: 'Easy',
  comparison_hard: 'Hard',
  comparison_seller: 'Seller research',
  comparison_seller_easy: 'Easy',
  comparison_seller_slow: 'Slow',
  comparison_discovery: 'Product discovery',
  comparison_discovery_high: 'High',
  comparison_discovery_med: 'Medium',

  // Safety
  safety_title: 'Research with more information before buying',
  safety_desc: 'Online information can change. Prices, stock, sellers and shipping costs should always be verified before purchasing. This is an independent informational resource.',
  safety_note: 'Always verify current product, seller, price and shipping information before purchasing.',

  // FAQ
  faq_title: 'Frequently Asked Questions',
  faq_q1: 'What is a CSSBuy Spreadsheet?',
  faq_a1: 'The CSSBuy Spreadsheet is an organized tool that brings together information about products, sellers, prices and quality check (QC) reviews available on the CSSBuy platform. It allows you to compare options and make more informed decisions before buying.',
  faq_q2: 'How to use the CSSBuy Spreadsheet?',
  faq_a2: 'You can use the CSSBuy Spreadsheet by browsing product categories, filtering by item type, seller or price. Each entry typically contains links to products, seller information and QC photos for quality verification.',
  faq_q3: 'Is CSSBuy legit?',
  faq_a3: 'CSSBuy is a known shopping agent platform that facilitates buying products from China. Like any online platform, it is important to verify sellers and reviews before making purchases. This site is an independent informational resource.',
  faq_q4: 'Is CSSBuy safe?',
  faq_a4: 'Safety depends on how you use the platform. Always research sellers, check QC photos, use secure payment methods and read refund policies before buying.',
  faq_q5: 'How much does CSSBuy shipping cost?',
  faq_a5: 'Shipping costs vary based on weight, dimensions, destination and chosen shipping method. We recommend using the shipping calculator on the CSSBuy platform to get accurate estimates.',
  faq_q6: 'What are QC photos?',
  faq_a6: 'QC (Quality Check) photos are detailed images of the product taken at the warehouse before shipping. They allow you to verify the quality, color, size and details of the item before approving the shipment.',

  // CTA
  cta_title: 'Ready to explore the CSSBuy Spreadsheet?',
  cta_button_1: 'Explore CSSBuy Spreadsheet',
  cta_button_2: 'Visit Main Website',

  // Footer
  footer_resources: 'Resources',
  footer_spreadsheet: 'Spreadsheet',
  footer_guides: 'Guides',
  footer_safety: 'Safety',
  footer_disclaimer: 'Disclaimer',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_about: 'About',
  footer_languages: 'Languages',
  footer_independent: 'Independent informational resource. Not officially affiliated with CSSBuy unless explicitly stated.',

  // Article Page
  article_breadcrumb_home: 'Home',
  article_breadcrumb_article: 'Article',
  article_related_articles: 'Related Articles',
  article_back_home: 'Back to Home',
  article_last_updated: 'Last updated',
  article_written_by: 'Written by',
  article_author_name: 'CSSBuy Research Team',

  // 404
  notfound_title: 'Page not found',
  notfound_desc: 'The page you are looking for does not exist or has been moved.',
  notfound_back: 'Back to Home',

  // Meta
  meta_title: 'CSSBuy Spreadsheet – Products, Sellers & Buying Resources',
  meta_description: 'Explore a curated CSSBuy Spreadsheet with product resources, seller information, QC guides, shipping information and practical buying tips.',
  meta_keywords: 'CSSBuy, CSSBuy Spreadsheet, CSSBuy products, CSSBuy sellers, CSSBuy guide',
};